module.exports = __webpack_public_path__ + "static/media/arrow-right-white.aa28b91e.svg";